import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (!authService.isAuthenticated()) {
    localStorage.setItem('redirectUrl', state.url);
    router.navigate(['/auth/login']);
    return false;
  } else {
    return true;
  }
};

export const publicGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (authService.isAuthenticated()) {
    const lastVisitedUrl = localStorage.getItem('lastVisitedUrl') || '/crm/class-control';
    router.navigateByUrl(lastVisitedUrl);
    return false;
  } else {
    return true;
  }
};